import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";

import { Divider } from "antd";
import { InputDateTime } from "../../../../core/components/form";

import { Form, Select, Input } from "formik-antd";

import { BasicForm } from "../../../../core/components/form";

import Moment from "moment-timezone";
import { DATETIME_FORMAT } from "../../../../core/utils/i18n-js";

import { createDate, nowWithTimezone, getDefaultTimezone } from "../../../../core/utils/timezones";

const LoginSchema = Yup.object().shape({
    externalId: Yup.string().required("Project code cannot be blank."),
    project: Yup.string().nullable().required("Project cannot be blank."),
    name: Yup.string().required("Name cannot be blank."),
    manager: Yup.string().nullable().required("Manager cannot be blank."),
    clientDeadlineAt: Yup.date().required("Cannot be blank.").typeError("Must be a date"),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
};

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

/**
 *
 */
export default class Formulario extends React.Component {
    constructor() {
        super();
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _initialForm = () => {
        const { alta, data } = this.props;

        if (!alta && data && data.timestamp) {
            let lqa = [];
            const clientDeadlineAt = createDate(data.quote.clientDeadlineAt, data.quote.clientDeadlineAtTimezone);

            return {
                project: data.quote && data.quote.project ? data.quote.project.id : "",
                pointOfSale: data.quote && data.quote.pointOfSale ? data.quote.pointOfSale.id : "",
                component: data.quote && data.quote.component ? data.quote.component.id : "",
                manager: data.quote && data.quote.manager ? data.quote.manager.id : "",
                clientDeadlineAt: clientDeadlineAt,
                notes: data.quote.notes,
                receivableCode: data.quote.receivableCode,
                name: data.quote.name,
                externalId: data.quote.externalId,
            };
        } else {
            const clientDeadlineAt = nowWithTimezone();

            return {
                manager: "",
                project: "",
                pointOfSale: "",
                component: "",
                clientDeadlineAt: clientDeadlineAt,
                notes: "",
                receivableCode: "",
                name: "",
                externalId: "",
            };
        }
    };

    render() {
        return (
            <BasicForm
                onPressBack={this._goBack}
                titulo="ADD QUOTE"
                subtitulo="FORM"
                initialValues={this._initialForm()}
                validationSchema={LoginSchema}
                onSubmit={this.props.handleSubmit}
                render={({ isSubmitting, touched, errors, values, setFieldValue }) => (
                    <>
                        <Form.Item
                            label="LP / LR / E-ID"
                            name="externalId"
                            hasFeedback={true}
                            showValidateSuccess={true}
                            required
                        >
                            <Input name="externalId" placeholder="LP / LR / External ID" />
                        </Form.Item>

                        <Form.Item label="Name" name="name" hasFeedback={true} showValidateSuccess={true} required>
                            <Input name="name" placeholder="Name" />
                        </Form.Item>

                        <Form.Item
                            label="Project"
                            name="project"
                            hasFeedback={true}
                            showValidateSuccess={true}
                            required
                        >
                            <Select
                                placeholder="Project"
                                name="project"
                                showSearch
                                options={this.props.projects}
                                filterOption={_filter}
                                onChange={(e) => {
                                    setFieldValue("pointOfSale", null);
                                    setFieldValue("component", null);
                                    setFieldValue("project", e);
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Point Of Sale"
                            name="pointOfSale"
                            hasFeedback={true}
                            showValidateSuccess={true}
                        >
                            <Select
                                placeholder="Point Of Sale"
                                name="pointOfSale"
                                showSearch
                                options={this.props.pointOfSalesByProject(values.project)}
                                filterOption={_filter}
                            />
                        </Form.Item>

                        <Form.Item label="Component" name="component">
                            <Select
                                placeholder="Component"
                                name="component"
                                showSearch
                                options={this.props.componentsByPointOfSale(values.pointOfSale)}
                                filterOption={_filter}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Receivable Code"
                            name="receivableCode"
                            hasFeedback={true}
                            showValidateSuccess={true}
                        >
                            <Input name="receivableCode" placeholder="Receivable Code" />
                        </Form.Item>

                        <Form.Item
                            label="Manager"
                            name="manager"
                            hasFeedback={true}
                            showValidateSuccess={true}
                            required
                        >
                            <Select
                                placeholder="Manager"
                                name="manager"
                                showSearch
                                options={this.props.managers}
                                filterOption={_filter}
                            />
                        </Form.Item>

                        <InputDateTime
                            name="clientDeadlineAt"
                            label="Client Deadline At"
                            placeholder="Client Deadline At"
                            errors={errors.clientDeadlineAt}
                            touched={touched.clientDeadlineAt}
                            layout="horizontal"
                            formItemLayout={formItemLayout}
                            showTime={{ format: "HH:mm", minuteStep: 15 }}
                            format={DATETIME_FORMAT}
                            defaultTimezone={
                                values.clientDeadlineAt ? values.clientDeadlineAt.tz() : getDefaultTimezone()
                            }
                        />

                        <Form.Item label="Notes" name="notes">
                            <Input.TextArea name="notes" placeholder="Notes" />
                        </Form.Item>

                        <Divider plain />
                    </>
                )}
            />
        );
    }
}
